export default __webpack_public_path__ + "static/media/NR-CW530HVK1.25277753.jpg";